import React from 'react'
import { Row, Col } from 'reactstrap';

import Fact from './_homeFact';

export default (props) => {
  const { adaptive, grandmaster, patterns, personalized, science } = props.factsData;
  return (
    <Row className="my-3">
      <Col className="my-3">
        <Fact
          path={personalized.slug}
          title={personalized.title}
          text={personalized.subtitle}
        />
      </Col>
      <Col className="my-3">
        <Fact
          path={patterns.slug}
          title={patterns.title}
          text={patterns.subtitle}
        />
      </Col>
      <Col className="my-3">
        <Fact
          path={grandmaster.slug}
          title={grandmaster.title}
          text={grandmaster.subtitle}
        />
      </Col>
      <Col className="my-3">
      <Fact
      path={science.slug}
      title={science.title}
      text={science.subtitle}
      />
      </Col>
      <Col className="my-3">
        <Fact
          path={adaptive.slug}
          title={adaptive.title}
          text={adaptive.subtitle}
        />
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/pages/index/_homeFactList.js